import axios from "./axios";

class SubscriptionService {
  subscription = async (packageName) => {
    try {
      const response = await axios.post("/subscription/", {
        package_name: packageName,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  status = async (packageName) => {
    try {
      const response = await axios.post("/subscription/status", {
        package_name: packageName,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchCommercial = async (packageName) => {
    try {
      const response = await axios.post("/subscription/commercial", {
        package_name: packageName,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new SubscriptionService();
